import { QTD_DEPENDENTES_ENUM, IDADE_ENUM } from '../helpers/funcoesPadroes';

export const validarQuantidadeDep = (valorForm, quantidadeDependentesExistentes) => {
    if (quantidadeDependentesExistentes >= QTD_DEPENDENTES_ENUM.dez && valorForm.Nome.length) {
        return true;
    }

    return false;
};

export const validarCategoria = valorForm => {
    if (valorForm.Categoria === 'ZCA64' && valorForm.Idade > IDADE_ENUM.sessentaCinco) {
        return {
            status: true,
            msg: 'Para a categoria ZELO COLINA ATÉ 64, o dependente precisa ser menor que 65 anos.'
        };
    }

    if (valorForm.Categoria === 'ZCM65' && valorForm.Idade < IDADE_ENUM.setentaSeis) {
        return {
            status: true,
            msg: 'Para a categoria ZELO COLINA MAIOR 65, o dependente precisa ser maior que 64 anos.'
        };
    }

    return {
        status: false,
        msg: ''
    };
};

export const validarLimiteCategoria = (dependentes, valorForm) => {
    let limitDepSemValorAdicional = 0;
    let limiteDepEspecial = 0;

    const mensagensErro = {
        limiteExcedidoSemValorAdicional: 'Dependentes sem valor adicional excedido!',
        limteExcedidoDepExpecial: 'Dependentes com valor adicional excedido!'
    };

    for (const dep of dependentes) {
        if (dep.Seq === valorForm.Seq) {
            continue;
        }

        const categoria = dep['CategoriaParentesco.Categoria'] ?? dep.Categoria;

        if (categoria === 'ZELO') {
            limitDepSemValorAdicional++;
        } else {
            limiteDepEspecial++;
        }
    }

    if (valorForm.Categoria === 'ZELO') {
        if (limitDepSemValorAdicional >= QTD_DEPENDENTES_ENUM.sete) {
            return mensagensErro.limiteExcedidoSemValorAdicional;
        }
    } else {
        if (limiteDepEspecial >= QTD_DEPENDENTES_ENUM.tres) {
            return mensagensErro.limteExcedidoDepExpecial;
        }
    }
};

export const qtdTotalDepentes = dependentes => {
    const qtdDependentes = dependentes.length;

    return qtdDependentes;
};

export const comparaRegrasDepAtuaisComDepUpSell = (dependentes, subGrupoSelecionadoUpSell) => {
    const qtdTotalDependentes = qtdTotalDepentes(dependentes);

    if (qtdTotalDependentes > QTD_DEPENDENTES_ENUM.dez) {
        return 'Para este plano só é permitido 10 dependentes. Por favor, remova os dependentes excedentes para continuar!';
    }

    let limitDepSemValorAdicional = 0;
    let limiteDepEspecial = 0;

    for (const dep of dependentes) {
        const categoria = dep.Categoria;

        const mensagensErro = {
            categoriaNaoPermitida: `O dependente com a sequência ${dep.Seq} possui uma categoria inválida (${categoria}) para o plano ${subGrupoSelecionadoUpSell}. Por favor, edite ou remova o dependente para continuar.`,
            depForaDaSeqPermitida: `E preciso Adicionar 7 dependentes sem valor adicional antes de incluir dependentes especiais. Verifique o dependente na sequência ${dep.Seq}.`,
            limiteExcedidoSemValorAdicional: 'Limite de dependentes sem valor adicional excedido, o máximo de dependentes sem valor adicional é 7!',
            limteExcedidoDepExpecial: 'Limite de dependentes especiais excedido, o máximo de dependentes especiais é 3!'
        };

        const categoriasPermitidas = ['ZELO', 'ZCA64', 'ZCM65'];

        if (!categoriasPermitidas.includes(categoria)) {
            return mensagensErro.categoriaNaoPermitida;
        }

        if (categoria === 'ZELO') {
            limitDepSemValorAdicional++;

            if (limitDepSemValorAdicional > QTD_DEPENDENTES_ENUM.sete) {
                return mensagensErro.limiteExcedidoSemValorAdicional;
            }
        } else {
            if (limitDepSemValorAdicional < QTD_DEPENDENTES_ENUM.sete) {
                return mensagensErro.depForaDaSeqPermitida;
            }

            limiteDepEspecial++;

            if (limiteDepEspecial > QTD_DEPENDENTES_ENUM.tres) {
                return mensagensErro.limteExcedidoDepExpecial;
            }
        }
    }

    return;
};
